// SF Symbols SVG registry.
// To add a new icon: export from SF Symbols app → run extract.py → uncomment here.

// ── Actions ──────────────────────────────────────────────────────────────────
import { ReactComponent as PaperplaneFill }      from './paperplane.fill.svg';
import { ReactComponent as Plus }                from './plus.svg';
import { ReactComponent as Xmark }               from './xmark.svg';
import { ReactComponent as XmarkCircleFill }      from './xmark.circle.fill.svg';
import { ReactComponent as Magnifyingglass }      from './magnifyingglass.svg';
import { ReactComponent as SquareAndPencil }      from './square.and.pencil.svg';
import { ReactComponent as Trash }                from './trash.svg';
import { ReactComponent as ArrowClockwise }       from './arrow.clockwise.svg';
import { ReactComponent as ArrowUpCircleFill }    from './arrow.up.circle.fill.svg';
import { ReactComponent as ArrowDownCircleFill }  from './arrow.down.circle.fill.svg';
import { ReactComponent as SquareAndArrowUp }     from './square.and.arrow.up.svg';
import { ReactComponent as BarcodeViewfinder }    from './barcode.viewfinder.svg';
import { ReactComponent as QrcodeViewfinder }     from './qrcode.viewfinder.svg';
import { ReactComponent as Ellipsis }             from './ellipsis.svg';
import { ReactComponent as EllipsisCircle }       from './ellipsis.circle.svg';
import { ReactComponent as EllipsisCircleFill }   from './ellipsis.circle.fill.svg';
import { ReactComponent as PlusCircleFill }                         from './plus.circle.fill.svg';
import { ReactComponent as PencilCircleFill }                       from './pencil.circle.fill.svg';
import { ReactComponent as TrashFill }                              from './trash.fill.svg';
import { ReactComponent as Barcode }                                from './barcode.svg';
import { ReactComponent as ShippingboxFill }                        from './shippingbox.fill.svg';
import { ReactComponent as ShippingboxAndArrowBackwardFill }        from './shippingbox.and.arrow.backward.fill.svg';
import { ReactComponent as ArrowLeftArrowRight }                    from './arrow.left.arrow.right.svg';
import { ReactComponent as NumberSquareFill }                       from './number.square.fill.svg';
import { ReactComponent as SquareAndArrowDownFill }                 from './square.and.arrow.down.fill.svg';
import { ReactComponent as ClockArrowCirclepath }                   from './clock.arrow.trianglehead.counterclockwise.rotate.90.svg';
import { ReactComponent as Eye }                  from './eye.svg';
import { ReactComponent as LockFill }             from './lock.fill.svg';
import { ReactComponent as PersonBadgePlus }      from './person.badge.plus.svg';
import { ReactComponent as Printer }              from './printer.svg';

// ── Navigation ───────────────────────────────────────────────────────────────
import { ReactComponent as ChevronLeft }          from './chevron.left.svg';
import { ReactComponent as ChevronRight }         from './chevron.right.svg';
import { ReactComponent as ChevronDown }          from './chevron.down.svg';
import { ReactComponent as ChevronUp }            from './chevron.up.svg';
import { ReactComponent as ChevronLeftCircle }    from './chevron.left.circle.svg';
import { ReactComponent as ChevronRightCircle }   from './chevron.right.circle.svg';

// ── States & Indicators ──────────────────────────────────────────────────────
import { ReactComponent as BoltFill }                      from './bolt.fill.svg';
import { ReactComponent as BoltSlash }                     from './bolt.slash.svg';
import { ReactComponent as BoltSlashFill }                 from './bolt.slash.fill.svg';
import { ReactComponent as FlashlightOffFill }             from './flashlight.off.fill.svg';
import { ReactComponent as CheckmarkCircleFill }           from './checkmark.circle.fill.svg';
import { ReactComponent as XCircleFill }                   from './x.circle.fill.svg';
import { ReactComponent as Checkmark }                     from './checkmark.svg';
import { ReactComponent as CheckmarkCircle }               from './checkmark.circle.svg';
import { ReactComponent as Circle }                        from './circle.svg';
import { ReactComponent as ExclamationmarkTriangleFill }   from './exclamationmark.triangle.fill.svg';
import { ReactComponent as InfoCircle }                    from './info.circle.svg';
import { ReactComponent as Flag }                          from './flag.svg';
import { ReactComponent as FlagFill }                      from './flag.fill.svg';
import { ReactComponent as StarFill }                      from './star.fill.svg';
import { ReactComponent as Sparkles }                      from './sparkles.svg';
import { ReactComponent as WaveformPathEcgRectangle }      from './waveform.path.ecg.rectangle.svg';

// ── Location & People ────────────────────────────────────────────────────────
import { ReactComponent as Building2 }                            from './building.2.svg';
import { ReactComponent as MappinCircleFill }                     from './mappin.circle.fill.svg';
import { ReactComponent as PersonCropCircleBadgeQuestionmark }    from './person.crop.circle.badge.questionmark.svg';
import { ReactComponent as Person2 }                              from './person.2.svg';

// ── Settings ─────────────────────────────────────────────────────────────────
import { ReactComponent as Gearshape2Fill }                       from './gearshape.2.fill.svg';

// ── Financial ────────────────────────────────────────────────────────────────
import { ReactComponent as Banknote }           from './banknote.svg';
import { ReactComponent as Percent }            from './percent.svg';
import { ReactComponent as Creditcard }         from './creditcard.svg';
import { ReactComponent as CreditcardFill }     from './creditcard.fill.svg';
import { ReactComponent as DollarsignCircle }   from './dollarsign.circle.svg';
import { ReactComponent as Cart }               from './cart.svg';
import { ReactComponent as ChartBar }           from './chart.bar.svg';
import { ReactComponent as Minus }              from './minus.svg';

// ── Repair Statuses ──────────────────────────────────────────────────────────
import { ReactComponent as PersonBadgeClock }              from './person.badge.clock.svg';
import { ReactComponent as PersonCropCircleBadgeClock }    from './person.crop.circle.badge.clock.svg';
import { ReactComponent as ExclamationmarkTriangle }        from './exclamationmark.triangle.svg';
import { ReactComponent as AirplaneDeparture }             from './airplane.departure.svg';
import { ReactComponent as Shippingbox }                   from './shippingbox.svg';
import { ReactComponent as FigureWalk }                    from './figure.walk.svg';
import { ReactComponent as HandThumbsup }                  from './hand.thumbsup.svg';
import { ReactComponent as Clock }                         from './clock.svg';
import { ReactComponent as Nosign }                        from './nosign.svg';
import { ReactComponent as WrenchAdjustable }              from './wrench.adjustable.svg';
import { ReactComponent as CheckmarkSeal }                 from './checkmark.seal.svg';
import { ReactComponent as XmarkCircle }                   from './xmark.circle.svg';
import { ReactComponent as ClockBadgeQuestionmark }        from './clock.badge.questionmark.svg';

// ── Repair Detail Quick Actions ───────────────────────────────────────────────
import { ReactComponent as CheckmarkShield }         from './checkmark.shield.svg';
import { ReactComponent as Stethoscope }             from './stethoscope.svg';
import { ReactComponent as BellBadge }               from './bell.badge.svg';
import { ReactComponent as ExclamationmarkBubble }   from './exclamationmark.bubble.svg';
import { ReactComponent as TextPadHeader }           from './text.pad.header.svg';
import { ReactComponent as ListClipboard }           from './list.clipboard.svg';
import { ReactComponent as CircleGrid3x3Fill }       from './circle.grid.3x3.fill.svg';

// ── Communication & Scheduling ────────────────────────────────────────────────
import { ReactComponent as Calendar }   from './calendar.svg';
import { ReactComponent as Envelope }   from './envelope.svg';
import { ReactComponent as Phone }      from './phone.svg';

// ── Empty States ─────────────────────────────────────────────────────────────
import { ReactComponent as FolderBadgeQuestionmark }         from './folder.badge.questionmark.svg';
import { ReactComponent as Line3HorizontalDecreaseCircle }   from './line.3.horizontal.decrease.circle.svg';

// ── Device Types ─────────────────────────────────────────────────────────────
import { ReactComponent as Smartphone }         from './smartphone.svg';
import { ReactComponent as Laptopcomputer }     from './laptopcomputer.svg';
import { ReactComponent as Desktopcomputer }    from './desktopcomputer.svg';
import { ReactComponent as Tv }                 from './tv.svg';
import { ReactComponent as Camera }             from './camera.svg';
import { ReactComponent as Hifispeaker }        from './hifispeaker.svg';
import { ReactComponent as Headphones }         from './headphones.svg';
import { ReactComponent as Gamecontroller }     from './gamecontroller.svg';
import { ReactComponent as IpadRearCamera }     from './ipad.rear.camera.svg';
import { ReactComponent as WatchAnalog }        from './watch.analog.svg';
import { ReactComponent as WrenchAndScrewdriver } from './wrench.and.screwdriver.svg';

// ── Layout ───────────────────────────────────────────────────────────────────
import { ReactComponent as RectangleSplit3x1 } from './rectangle.split.3x1.svg';

// ── Inventory tiles ──────────────────────────────────────────────────────────
import { ReactComponent as ListBulletRectanglePortrait }          from './list.bullet.rectangle.portrait.svg';
import { ReactComponent as LaptopcomputerAndIphone }              from './laptopcomputer.and.iphone.svg';
import { ReactComponent as DollarsignArrowCirclepath }            from './dollarsign.arrow.circlepath.svg';

export const SF_SYMBOLS = {
  // ── Actions ────────────────────────────────────────────────────────────────
  'paperplane.fill':                         PaperplaneFill,
  'plus':                                    Plus,
  'xmark':                                   Xmark,
  'xmark.circle.fill':                       XmarkCircleFill,
  'magnifyingglass':                         Magnifyingglass,
  'square.and.pencil':                       SquareAndPencil,
  'trash':                                   Trash,
  'arrow.clockwise':                         ArrowClockwise,
  'arrow.up.circle.fill':                    ArrowUpCircleFill,
  'arrow.down.circle.fill':                  ArrowDownCircleFill,
  'square.and.arrow.up':                     SquareAndArrowUp,
  'barcode.viewfinder':                      BarcodeViewfinder,
  'qrcode.viewfinder':                       QrcodeViewfinder,
  'ellipsis':                                Ellipsis,
  'ellipsis.circle':                         EllipsisCircle,
  'ellipsis.circle.fill':                    EllipsisCircleFill,
  'plus.circle.fill':                        PlusCircleFill,
  'pencil.circle.fill':                      PencilCircleFill,
  'trash.fill':                              TrashFill,
  'barcode':                                 Barcode,
  'shippingbox.fill':                        ShippingboxFill,
  'shippingbox.and.arrow.backward.fill':     ShippingboxAndArrowBackwardFill,
  'arrow.left.arrow.right':                  ArrowLeftArrowRight,
  'number.square.fill':                      NumberSquareFill,
  'square.and.arrow.down.fill':              SquareAndArrowDownFill,
  'clock.arrow.circlepath':                  ClockArrowCirclepath,
  'eye':                                     Eye,
  'lock.fill':                               LockFill,
  'person.badge.plus':                       PersonBadgePlus,
  'printer':                                 Printer,

  // ── Navigation ──────────────────────────────────────────────────────────────
  'chevron.left':                            ChevronLeft,
  'chevron.right':                           ChevronRight,
  'chevron.down':                            ChevronDown,
  'chevron.up':                              ChevronUp,
  'chevron.left.circle':                     ChevronLeftCircle,
  'chevron.right.circle':                    ChevronRightCircle,

  // ── States & Indicators ─────────────────────────────────────────────────────
  'bolt.fill':                               BoltFill,
  'bolt.slash':                              BoltSlash,
  'bolt.slash.fill':                         BoltSlashFill,
  'flashlight.off.fill':                     FlashlightOffFill,
  'checkmark.circle.fill':                   CheckmarkCircleFill,
  'x.circle.fill':                           XCircleFill,
  'checkmark':                               Checkmark,
  'checkmark.circle':                        CheckmarkCircle,
  'circle':                                  Circle,
  'exclamationmark.triangle.fill':           ExclamationmarkTriangleFill,
  'info.circle':                             InfoCircle,
  'flag':                                    Flag,
  'flag.fill':                               FlagFill,
  'star.fill':                               StarFill,
  'sparkles':                                Sparkles,
  'waveform.path.ecg.rectangle':             WaveformPathEcgRectangle,

  // ── Location & People ───────────────────────────────────────────────────────
  'building.2':                              Building2,
  'mappin.circle.fill':                      MappinCircleFill,
  'person.crop.circle.badge.questionmark':   PersonCropCircleBadgeQuestionmark,
  'person.2':                                Person2,

  // ── Settings ────────────────────────────────────────────────────────────────
  'gearshape.2.fill':                        Gearshape2Fill,

  // ── Financial ───────────────────────────────────────────────────────────────
  'banknote':                                Banknote,
  'percent':                                 Percent,
  'creditcard':                              Creditcard,
  'creditcard.fill':                         CreditcardFill,
  'dollarsign.circle':                       DollarsignCircle,
  'cart':                                    Cart,
  'chart.bar':                               ChartBar,
  'minus':                                   Minus,

  // ── Repair Statuses ─────────────────────────────────────────────────────────
  'person.badge.clock':                      PersonBadgeClock,
  'person.crop.circle.badge.clock':          PersonCropCircleBadgeClock,
  'exclamationmark.triangle':                ExclamationmarkTriangle,
  'airplane.departure':                      AirplaneDeparture,
  'shippingbox':                             Shippingbox,
  'figure.walk':                             FigureWalk,
  'hand.thumbsup':                           HandThumbsup,
  'clock':                                   Clock,
  'nosign':                                  Nosign,
  'wrench.adjustable':                       WrenchAdjustable,
  'checkmark.seal':                          CheckmarkSeal,
  'xmark.circle':                            XmarkCircle,
  'clock.badge.questionmark':                ClockBadgeQuestionmark,

  // ── Empty States ────────────────────────────────────────────────────────────
  'folder.badge.questionmark':               FolderBadgeQuestionmark,
  'line.3.horizontal.decrease.circle':       Line3HorizontalDecreaseCircle,

  // ── Device Types ────────────────────────────────────────────────────────────
  'smartphone':                              Smartphone,
  'laptopcomputer':                          Laptopcomputer,
  'desktopcomputer':                         Desktopcomputer,
  'tv':                                      Tv,
  'camera':                                  Camera,
  'hifispeaker':                             Hifispeaker,
  'headphones':                              Headphones,
  'gamecontroller':                          Gamecontroller,
  'ipad.rear.camera':                        IpadRearCamera,
  'watch.analog':                            WatchAnalog,
  'wrench.and.screwdriver':                  WrenchAndScrewdriver,

  // ── Repair Detail Quick Actions ─────────────────────────────────────────────
  'checkmark.shield':                        CheckmarkShield,
  'stethoscope':                             Stethoscope,
  'bell.badge':                              BellBadge,
  'exclamationmark.bubble':                  ExclamationmarkBubble,
  'text.pad.header':                         TextPadHeader,
  'list.clipboard':                          ListClipboard,
  'circle.grid.3x3.fill':                    CircleGrid3x3Fill,

  // ── Communication & Scheduling ───────────────────────────────────────────────
  'calendar':                                Calendar,
  'envelope':                                Envelope,
  'phone':                                   Phone,

  // ── Layout ──────────────────────────────────────────────────────────────────
  'rectangle.split.3x1':                     RectangleSplit3x1,

  // ── Inventory tiles ─────────────────────────────────────────────────────────
  'list.bullet.rectangle.portrait':          ListBulletRectanglePortrait,
  'laptopcomputer.and.iphone':               LaptopcomputerAndIphone,
  'dollarsign.arrow.circlepath':             DollarsignArrowCirclepath,
};
